export default __webpack_public_path__ + "static/media/twrice.7f2b7f20.jpg";